import { useContext } from "react";
import SettingContext from '../contexts/SettingsContext';

const useSettings = () =>  useContext(SettingContext);

export default useSettings;